import React, { Fragment, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import InfoEditCard from "../../components/Cards/InfoEditCard";
import InfoAddCard from "../../components/Cards/InfoAddCard";
import { FaGraduationCap, FaUserTie } from "react-icons/fa";
import { PiBagFill } from "react-icons/pi";
import { HiLightBulb } from "react-icons/hi";
import { MdClear } from "react-icons/md";
import { IoIosSearch } from "react-icons/io";
import axiosInstance from "../../services/api/axiosInstance";
import { BsFillArrowUpCircleFill } from "react-icons/bs";
import images from "../../utils/images";
import toast from 'react-hot-toast';
import CandidateProfile from './CandidateProfile';
import InputGroup from 'components/Input/InputGroup';
import { Button, Form, Modal } from 'react-bootstrap';
import { FaArrowLeftLong } from 'react-icons/fa6';


const BestFitCandidates = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const applicants_job_id = queryParams.get("applicants_job");

    const pageRender = useNavigate();
    const [mobileScreen, setMobileScreen] = useState(window.innerWidth)
    const [invitedApplicants, setnvitedApplicants] = useState([])
    const [pageContentLoaded, setPageContentLoaded] = useState(false)
    const [professionalId, setProfessionalId] = useState(null);
    const [isVisible, setIsVisible] = useState(false);
    const [isSearched, setIsSearched] = useState(false);
    const [isSearchedOnce, setIsSearchedOnce] = useState(false);
    const [poolSearch, setPoolSearch] = useState("");
    const [sendInviteData, setSendInviteData] = useState({
        professional_id: '',
        job_id: '',
        employer_feedback: '',
        job_title: ''
    })

    //modal handling
    const [show, setShow] = useState(false);
    const handleInterviewModal = () => setShow(!show);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            setPageContentLoaded(false)
            const { data } = await axiosInstance.post("/best_fit_applicants", { job_id: applicants_job_id });
            if (data?.error_code === 0) {
                setnvitedApplicants(data?.data?.final_result)
                setSendInviteData({
                    employer_feedback: '',
                    job_id: applicants_job_id,
                    professional_id: '',
                    job_title: data?.data?.job_title || ''
                })

                setPageContentLoaded(true)
            } else {
                toast.error(data?.message);
                setPageContentLoaded(false)
            }
        } catch (err) {
            toast.error(err.message);
            setPageContentLoaded(false)
        }
    };

    // Function to handle scroll event
    const handleScroll = () => {
        if (window.pageYOffset > 200) {
            // Adjust this value according to your needs
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    // Function to scroll to the top of the page
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth", // Optional: smooth scrolling animation
        });
    };

    // Add scroll event listener
    window.addEventListener("scroll", handleScroll);
    const handleResize = () => {
        const screenWidth = window.innerWidth;
        if (screenWidth < 588) {
            setMobileScreen(screenWidth);
        } else {
            setMobileScreen(null);
        }
    };

    useEffect(() => {
        handleResize();

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleViewFullProfile = async (professionalId) => {
        setProfessionalId(professionalId);
    };

    const handlePoolSearch = (e) => {
        if (!isSearched) {
            setIsSearched(true);
        }
        setPoolSearch(e.target.value);
    };

    //search endpoint
    const handleSearchData = async (id, from_mail) => {
        setPageContentLoaded(false);

        if (!isSearchedOnce || id === 0) {
            setnvitedApplicants([]);
            setIsSearchedOnce(true);
        }

        try {
            const obj = {
                job_id: applicants_job_id,
                search_text: poolSearch.trim(),
                search_req_from: "best_fit_applicants"
            };

            const { data } = await axiosInstance.post("/invited_applicants_search", obj);
            if (data.error_code === 200) {
                setPageContentLoaded(true)
                setnvitedApplicants(data?.data?.final_result)
            } else {
                setPageContentLoaded(false);
            }
        } catch (Err) {
            console.log(Err);
        }
    };

    //search input enter key down
    const handlekeydown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            if (poolSearch) {
                setIsSearched(true);
                handleSearchData(0);
            } else {
                toast.error("search field is empty");
            }
        }
    };

    //clear search
    const handleClearSearch = () => {
        setPoolSearch("");
        setIsSearchedOnce(false);

        if (isSearched) {
            setPageContentLoaded(false);
            setIsSearched(false);
            fetchData();
        }
    };

    const handleInterviewApi = async () => {
        try {
            if (sendInviteData?.professional_id) {
                let endpointParams = { ...sendInviteData }
                endpointParams.professional_id = sendInviteData?.professional_id?.split("-")?.length ? parseInt(sendInviteData?.professional_id?.split("-")[2]) : 0
                endpointParams.job_id = parseInt(sendInviteData?.job_id)

                const { data } = await axiosInstance.post("/invite_by_employer", { ...endpointParams, invite_from: "" })
                if (data.error_code === 0) {
                    setShow(false);
                } else {
                    toast.error(data?.message)
                }
            } else {
                toast.error("please select the job")
            }
        } catch (err) {
            console.log(err)
        }
    }

    return (
        <div className="homePage-backgroundColor overflow-hidden">
            <div className="container-fluid h-100">

                <div className="row pt-5">
                    <div className="col-12 col-lg-8 py-2 py-md-0">
                        <button
                            className="btn btn-transparent d-flex align-items-center gap-2"
                            onClick={() => {
                                pageRender("/employer_dashboard/candidates");
                            }}
                        >
                            <FaArrowLeftLong className="fs-5" /> Best Fit Applicants
                        </button>
                    </div>

                    <div className="col-12 col-lg-4 mb-lg-2">
                        {
                            sendInviteData?.job_title ?
                                <p className='w-100 mb-0'>
                                    <strong>Job Title : </strong>
                                    {sendInviteData?.job_title}
                                </p>
                                :
                                null
                        }
                    </div>

                    <div className="col-12 col-lg-8">
                        <p className='px-3 pt-3 mb-0 text-secondary fs-14'>
                            <span className="me-3">
                                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
                                    <path d="M11.9052 3.62712L13.9998 4.5004L14.8731 6.59501C14.8964 6.64181 14.9323 6.68119 14.9768 6.70871C15.0213 6.73623 15.0725 6.75081 15.1248 6.75081C15.1771 6.75081 15.2284 6.73623 15.2728 6.70871C15.3173 6.68119 15.3532 6.64181 15.3765 6.59501L16.2498 4.5004L18.3444 3.62712C18.3912 3.6038 18.4306 3.56788 18.4581 3.52342C18.4856 3.47895 18.5002 3.4277 18.5002 3.3754C18.5002 3.32311 18.4856 3.27185 18.4581 3.22739C18.4306 3.18292 18.3912 3.14701 18.3444 3.12368L16.2498 2.2504L15.3765 0.155794C15.3532 0.108992 15.3173 0.0696198 15.2728 0.0420993C15.2284 0.0145789 15.1771 0 15.1248 0C15.0725 0 15.0213 0.0145789 14.9768 0.0420993C14.9323 0.0696198 14.8964 0.108992 14.8731 0.155794L13.9998 2.2504L11.9052 3.12368C11.8584 3.14701 11.819 3.18292 11.7915 3.22739C11.764 3.27185 11.7494 3.32311 11.7494 3.3754C11.7494 3.4277 11.764 3.47895 11.7915 3.52342C11.819 3.56788 11.8584 3.6038 11.9052 3.62712ZM18.3444 14.3737L16.2498 13.5004L15.3765 11.4058C15.3532 11.359 15.3173 11.3196 15.2728 11.2921C15.2284 11.2646 15.1771 11.25 15.1248 11.25C15.0725 11.25 15.0213 11.2646 14.9768 11.2921C14.9323 11.3196 14.8964 11.359 14.8731 11.4058L13.9998 13.5004L11.9052 14.3737C11.8584 14.397 11.819 14.4329 11.7915 14.4774C11.764 14.5219 11.7494 14.5731 11.7494 14.6254C11.7494 14.6777 11.764 14.729 11.7915 14.7734C11.819 14.8179 11.8584 14.8538 11.9052 14.8771L13.9998 15.7504L14.8731 17.845C14.8964 17.8918 14.9323 17.9312 14.9768 17.9587C15.0213 17.9862 15.0725 18.0008 15.1248 18.0008C15.1771 18.0008 15.2284 17.9862 15.2728 17.9587C15.3173 17.9312 15.3532 17.8918 15.3765 17.845L16.2498 15.7504L18.3444 14.8771C18.3912 14.8538 18.4306 14.8179 18.4581 14.7734C18.4856 14.729 18.5002 14.6777 18.5002 14.6254C18.5002 14.5731 18.4856 14.5219 18.4581 14.4774C18.4306 14.4329 18.3912 14.397 18.3444 14.3737ZM13.9998 9.0004C13.9998 8.84364 13.9561 8.68998 13.8736 8.55665C13.7912 8.42333 13.6732 8.31562 13.5329 8.2456L9.84679 6.40271L8.00461 2.71693C7.71879 2.14564 6.78082 2.14564 6.495 2.71693L4.65246 6.40271L0.966677 8.2456C0.826456 8.31565 0.70852 8.42337 0.626091 8.55669C0.543662 8.69001 0.5 8.84366 0.5 9.0004C0.5 9.15715 0.543662 9.31079 0.626091 9.44411C0.70852 9.57744 0.826456 9.68516 0.966677 9.75521L4.65246 11.5981L6.495 15.2842C6.56505 15.4245 6.67277 15.5424 6.80609 15.6248C6.93941 15.7072 7.09306 15.7509 7.2498 15.7509C7.40655 15.7509 7.56019 15.7072 7.69351 15.6248C7.82683 15.5424 7.93456 15.4245 8.00461 15.2842L9.84679 11.5981L13.5329 9.75521C13.6732 9.68519 13.7912 9.57747 13.8736 9.44415C13.9561 9.31083 13.9998 9.15717 13.9998 9.0004ZM8.84168 10.2143C8.67813 10.296 8.5455 10.4285 8.46375 10.5919L7.2498 13.0198L6.03586 10.5919C5.9541 10.4285 5.82147 10.296 5.65793 10.2143L3.23004 9.0004L5.65793 7.78646C5.82142 7.70495 5.95404 7.57257 6.03586 7.40923L7.2498 4.98099L8.46375 7.40923C8.54556 7.57257 8.67818 7.70495 8.84168 7.78646L11.2696 9.0004L8.84168 10.2143Z" fill="orange" />
                                </svg>
                            </span>
                            AI recommends the 10 best-fit candidates for this job from the pool page (professionals who have not yet applied to this job)
                        </p>
                    </div>

                    <div className={pageContentLoaded || poolSearch ? "col-12 col-lg-4 row" : "d-none"} id="searchInputField">
                        <div className="d-flex position-relative col-12" >
                            <InputGroup
                                className="home-search-icon fs-5 px-3 "
                                reIcons={<IoIosSearch />}
                            />

                            <input
                                type="text"
                                className="form-control form-control-lg searchInput candidate-searchInput border-0 px-5 py-0 searchInput-border"
                                placeholder="Search by user id, skill, experience, education"
                                aria-label="default input example"
                                value={poolSearch}
                                onChange={(e) => handlePoolSearch(e)}
                                onKeyDown={handlekeydown}
                            />

                            {isSearched ? (
                                <div
                                    className="searchButtonClick-superAdmin "
                                    title="Search"
                                    onClick={() => handleSearchData(0)}
                                >
                                    <IoIosSearch />
                                </div>
                            ) : null}

                            <div
                                className="clearButtonClick-superAdmin"
                                title="Clear"
                                onClick={handleClearSearch}
                            >
                                <MdClear />
                            </div>
                        </div>
                    </div>

                    <div className={pageContentLoaded || poolSearch ? "col-12" : "d-none"}>
                        <p className='px-3 pt-2 mb-0 text-secondary fs-14'>
                            <strong>Showing : </strong>
                            {invitedApplicants?.length} results
                        </p>
                    </div>
                </div>


                {!pageContentLoaded ?
                    <>
                        <div className="card border-0 shadow-sm px-5 py-3 my-4 placeholder-glow ">
                            <div className="row">
                                <div className="col-lg-6 col-md-12">
                                    <InfoEditCard
                                        pageContentLoaded={pageContentLoaded}
                                        cardHeadingIcon={
                                            <FaUserTie
                                                className={
                                                    pageContentLoaded
                                                        ? "me-4 brand-color fs-4"
                                                        : "me-4  fs-4 placeholder rounded-2"
                                                }
                                            />
                                        }
                                        cardHeading="About"
                                        id="pageTop"
                                        placeholder="Provide a brief description about yourself"
                                        cardContent="about content"
                                    />
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <InfoEditCard
                                        pageContentLoaded={pageContentLoaded}
                                        cardHeadingIcon={
                                            <FaUserTie
                                                className={
                                                    pageContentLoaded
                                                        ? "me-4 brand-color fs-4"
                                                        : "me-4  fs-4 placeholder rounded-2"
                                                }
                                            />
                                        }
                                        cardHeading="About"
                                        id="pageTop"
                                        placeholder="Provide a brief description about yourself"
                                        cardContent="about content"
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-6 col-md-12">
                                    <div className="card mt-3 border-0 shadow-sm rounded-4">
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between ms-1">
                                                <label className="profile-side-headers d-flex align-items-center placeholder-glow">
                                                    <HiLightBulb
                                                        className={
                                                            pageContentLoaded
                                                                ? "me-4 brand-color fs-4"
                                                                : "me-4  fs-3 placeholder rounded-2"
                                                        }
                                                    />
                                                    <span
                                                        className={
                                                            pageContentLoaded
                                                                ? ""
                                                                : "placeholder px-3 w-100 py-1  rounded-1"
                                                        }
                                                    >
                                                        Skills
                                                    </span>
                                                </label>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="row row-cols-auto ms-5 g-3 profile-descriptions mt-3">
                                                    <p
                                                        className={
                                                            pageContentLoaded
                                                                ? "mt-0 word-space-content px-0 ms-1"
                                                                : "placeholder px-3 py-2 mt-0 rounded-1"
                                                        }
                                                    >
                                                        Your skills will be displayed here
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <InfoEditCard
                                        pageContentLoaded={pageContentLoaded}
                                        cardHeadingIcon={
                                            <FaUserTie
                                                className={
                                                    pageContentLoaded
                                                        ? "me-4 brand-color fs-4"
                                                        : "me-4  fs-4 placeholder rounded-2"
                                                }
                                            />
                                        }
                                        cardHeading="About"
                                        id="pageTop"
                                        placeholder="Provide a brief description about yourself"
                                        cardContent="about content"
                                    />
                                </div>
                            </div>

                            <div className="mt-4 text-end">
                                <button
                                    className={
                                        pageContentLoaded
                                            ? "btn btn-brand-color"
                                            : "btn  placeholder rounded-2"
                                    }
                                    data-bs-toggle="modal"
                                    data-bs-target="#fullProfileModal"
                                >
                                    Click here to see full profile
                                </button>
                            </div>
                        </div>
                        <div className="card border-0 shadow-sm px-5 py-3 my-4 placeholder-glow ">
                            <div className="row">
                                <div className="col-lg-6 col-md-12">
                                    <InfoEditCard
                                        pageContentLoaded={pageContentLoaded}
                                        cardHeadingIcon={
                                            <FaUserTie
                                                className={
                                                    pageContentLoaded
                                                        ? "me-4 brand-color fs-4"
                                                        : "me-4  fs-4 placeholder rounded-2"
                                                }
                                            />
                                        }
                                        cardHeading="About"
                                        id="pageTop"
                                        placeholder="Provide a brief description about yourself"
                                        cardContent="about content"
                                    />
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <InfoEditCard
                                        pageContentLoaded={pageContentLoaded}
                                        cardHeadingIcon={
                                            <FaUserTie
                                                className={
                                                    pageContentLoaded
                                                        ? "me-4 brand-color fs-4"
                                                        : "me-4  fs-4 placeholder rounded-2"
                                                }
                                            />
                                        }
                                        cardHeading="About"
                                        id="pageTop"
                                        placeholder="Provide a brief description about yourself"
                                        cardContent="about content"
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-lg-6 col-md-12">
                                    <div className="card mt-3 border-0 shadow-sm  rounded-4">
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between ms-1">
                                                <label className="profile-side-headers d-flex align-items-center placeholder-glow">
                                                    <HiLightBulb
                                                        className={
                                                            pageContentLoaded
                                                                ? "me-4 brand-color fs-4"
                                                                : "me-4  fs-3 placeholder rounded-2"
                                                        }
                                                    />
                                                    <span
                                                        className={
                                                            pageContentLoaded
                                                                ? ""
                                                                : "placeholder px-3 w-100 py-1  rounded-1"
                                                        }
                                                    >
                                                        Skills
                                                    </span>
                                                </label>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center">
                                                <div className="row row-cols-auto ms-5 g-3 profile-descriptions mt-3">
                                                    <p
                                                        className={
                                                            pageContentLoaded
                                                                ? "mt-0 word-space-content px-0 ms-1"
                                                                : "placeholder px-3 py-2 mt-0 rounded-1"
                                                        }
                                                    >
                                                        Your skills will be displayed here
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-12">
                                    <InfoEditCard
                                        pageContentLoaded={pageContentLoaded}
                                        cardHeadingIcon={
                                            <FaUserTie
                                                className={
                                                    pageContentLoaded
                                                        ? "me-4 brand-color fs-4"
                                                        : "me-4  fs-4 placeholder rounded-2"
                                                }
                                            />
                                        }
                                        cardHeading="About"
                                        id="pageTop"
                                        placeholder="Provide a brief description about yourself"
                                        cardContent="about content"
                                    />
                                </div>
                            </div>

                            <div className="mt-4 text-end">
                                <button
                                    className={
                                        pageContentLoaded
                                            ? "btn btn-brand-color"
                                            : "btn  placeholder rounded-2"
                                    }
                                    data-bs-toggle="modal"
                                    data-bs-target="#fullProfileModal"
                                >
                                    Click here to see full profile
                                </button>
                            </div>
                        </div>
                    </>
                    :
                    invitedApplicants?.length > 0 ?
                        invitedApplicants?.map((value, i) => {
                            return (
                                <React.Fragment key={value?.id}>
                                    {value?.about?.length === 0 &&
                                        value?.experience?.length === 0 &&
                                        value?.skills?.length === 0 &&
                                        value?.education?.length === 0 ? null : (
                                        <div
                                            className={`card  border-0 shadow-sm ${mobileScreen ? "px-3" : "px-5"
                                                } py-3 my-4 placeholder-glow h-100`}
                                        >
                                            <div className="row" id={i === 0 ? "firstCard" : ""}>
                                                <div className="card-header bg-transparent d-flex justify-content-between align-items-center">
                                                    <p className={pageContentLoaded ?
                                                        "mb-1"
                                                        :
                                                        "placeholder py-2 rounded-2"
                                                    }>
                                                        USER ID :{" "}
                                                        <strong>{value?.professional_id}</strong>
                                                    </p>

                                                    <div className={` ${mobileScreen ? "text-center" : "text-end"}`} id={`viewFullProfile${value?.id}Button`} >
                                                        <button id={`${i === 0 ? "clickToSeeProfile2" : ""}`}
                                                            className={pageContentLoaded ? `btn border-brand-color py-1` : "btn btn-sm placeholder rounded-2"}
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#fullProfileModal"
                                                            onClick={() =>
                                                                handleViewFullProfile(value?.professional_id)
                                                            }>
                                                            View full profile
                                                        </button>
                                                    </div>
                                                </div>
                                                {value.about.length === 0 ? null : (
                                                    <div className="col-lg-6 col-md-12 ">
                                                        <InfoEditCard
                                                            pageContentLoaded={pageContentLoaded}
                                                            cardHeadingIcon={
                                                                <FaUserTie
                                                                    className={pageContentLoaded ? "me-4 brand-color fs-4"
                                                                        : "me-4  fs-4 placeholder rounded-2"
                                                                    } />
                                                            }
                                                            cardHeading="About"
                                                            id="pageTop"
                                                            placeholder="Provide a brief description about yourself"
                                                            cardContent={value?.about?.length > 200 ?
                                                                `${value?.about?.slice(0, 250)}..`
                                                                : `${value?.about}`
                                                            }
                                                            mobileScreen={mobileScreen}
                                                        />
                                                    </div>
                                                )}

                                                {value?.experience?.length === 0 ? null : (
                                                    <div className="col-lg-6 col-md-12">
                                                        <InfoAddCard
                                                            pageContentLoaded={pageContentLoaded}
                                                            cardHeadingIcon={
                                                                <PiBagFill
                                                                    className={
                                                                        pageContentLoaded
                                                                            ? "me-4 brand-color fs-4"
                                                                            : "me-4  fs-4 placeholder rounded-2"
                                                                    }
                                                                />
                                                            }
                                                            cardHeading="Experience"
                                                            placeholder="Your experience details will be displayed here"
                                                            arrayContent={value?.experience[0]}
                                                            currentPage="employerPool"
                                                            mobileScreen={mobileScreen}
                                                        />
                                                    </div>
                                                )}
                                                {value?.skills?.length === 0 ? null : (
                                                    <div className="col-lg-6 col-md-12">
                                                        <div className="card mt-3 border-0 rounded-4">
                                                            <div
                                                                className={`card-body ${mobileScreen ? "px-0 py-0" : ""
                                                                    }`}
                                                            >
                                                                <div className="d-flex justify-content-between ms-1">
                                                                    <label className="profile-side-headers d-flex align-items-center placeholder-glow">
                                                                        <HiLightBulb
                                                                            className={
                                                                                pageContentLoaded
                                                                                    ? "me-4 brand-color fs-4"
                                                                                    : "me-4  fs-3 placeholder rounded-2"
                                                                            }
                                                                        />
                                                                        <span
                                                                            className={
                                                                                pageContentLoaded
                                                                                    ? ""
                                                                                    : "placeholder px-3 w-100 py-1  rounded-1"
                                                                            }
                                                                        >
                                                                            Skills
                                                                        </span>
                                                                    </label>
                                                                </div>

                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <div className="row row-cols-auto ms-5 g-3 profile-descriptions mt-3">
                                                                        {value?.skills?.length === 0 ? (
                                                                            <p
                                                                                className={
                                                                                    pageContentLoaded
                                                                                        ? "mt-0 word-space-content px-0 ms-1"
                                                                                        : "placeholder px-3 py-2 mt-0 rounded-1"
                                                                                }
                                                                            >
                                                                                Your skills will be displayed here
                                                                            </p>
                                                                        ) : (
                                                                            value?.skills
                                                                                .slice(0, 5)
                                                                                .map((skill, id) => {
                                                                                    return (
                                                                                        <React.Fragment key={skill?.id}>
                                                                                            <div className="col mt-0  px-0 me-2">
                                                                                                <div
                                                                                                    className={
                                                                                                        pageContentLoaded
                                                                                                            ? "border rounded-2 p-2 fw-bold mb-3 "
                                                                                                            : "border rounded-2 p-2 fw-bold mb-4 placeholder"
                                                                                                    }
                                                                                                >
                                                                                                    <span className="textTransform">
                                                                                                        {skill?.skill_name}
                                                                                                    </span>{" "}
                                                                                                    {skill?.skill_level
                                                                                                        ? "-"
                                                                                                        : null}{" "}
                                                                                                    <span className="fw-normal">
                                                                                                        {skill?.skill_level}
                                                                                                    </span>
                                                                                                </div>
                                                                                            </div>
                                                                                        </React.Fragment>
                                                                                    );
                                                                                })
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {value.education.length === 0 ? null : (
                                                    <div className="col-lg-6 col-md-12">
                                                        <InfoAddCard
                                                            pageContentLoaded={pageContentLoaded}
                                                            cardHeadingIcon={
                                                                <FaGraduationCap
                                                                    className={
                                                                        pageContentLoaded
                                                                            ? "me-4 brand-color fs-4"
                                                                            : "me-4  fs-4 placeholder rounded-2"
                                                                    }
                                                                />
                                                            }
                                                            cardHeading="Education"
                                                            placeholder="Your education details will be displayed here"
                                                            arrayContent={value.education[0]}
                                                            currentPage="employerPool"
                                                            mobileScreen={mobileScreen}
                                                        />
                                                    </div>
                                                )}
                                                <hr />
                                            </div>

                                            <div >
                                                <div className={`mt-2 ${mobileScreen ? "text-center" : "text-end"}`} id={`inviteToInterview${value.id}Button`}>
                                                    <button id={`${i === 0 ? "clickToSeeProfile2" : ""}`} className={pageContentLoaded ? "btn btn-brand-color" : "btn  placeholder rounded-2"}
                                                        onClick={() => {
                                                            setShow(true)
                                                            setSendInviteData({ ...sendInviteData, professional_id: value?.professional_id })
                                                        }}
                                                    >
                                                        Invite to Apply
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </React.Fragment>
                            );
                        })
                        :
                        <div className="h-100">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                <div className="d-flex  justify-content-center vh-80 align-items-center">
                                    <img
                                        src={images.noRecordsFound}
                                        width={250}
                                        height={250}
                                    />
                                </div>
                            </div>
                        </div>
                }
            </div>

            <div className="scroll-to-top-icon"
                id="scroll-to-top-icon"
                onClick={scrollToTop}
                title="Scroll to top"
                style={{ display: isVisible ? "block" : "none" }}
            >
                <BsFillArrowUpCircleFill className="fs-1 brand-color" />
            </div>


            {/* invite to interview model */}
            <div className="inviteInterview-modal-container">
                <Modal
                    backdrop="static"
                    keyboard={false}
                    show={show}
                    onHide={handleInterviewModal}
                    size="lg"
                    centered>

                    <Modal.Header closeButton>
                        <Modal.Title><h5 className="fw-bold p-2">Invite to Apply</h5></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="inviteInterview-modal-body d-flex flex-column p-3">
                            <Fragment>
                                <div className="inviteInterview-selectJob d-flex flex-column">
                                    <h6 className="fw-bold">Selected Job</h6>

                                    <input type="text" className='form-control' value={sendInviteData?.job_title} disabled />
                                </div>
                                <div className="inviteInterview-InputText mt-4">
                                    <h6 className="fw-bold ">Why would you like this professional to apply for this job?</h6>
                                    <p className="fs-6">This message will be shared with the professional to provide context for the invitation. (Optional)</p>
                                    <Form.Control as="textarea" rows={7} placeholder="Enter Your Text Here" onChange={(e) => setSendInviteData({ ...sendInviteData, employer_feedback: e.target.value })}></Form.Control>

                                </div>
                            </Fragment>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="d-flex w-100">
                            <Button
                                variant="outline-secondary"
                                className="mx-2 w-50"
                                onClick={handleInterviewModal}
                            >
                                Cancel
                            </Button>


                            <Button
                                variant="brand-color"
                                className="w-50"
                                onClick={handleInterviewApi}
                            >
                                Invite
                            </Button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>


            <div
                className="modal fade"
                id="fullProfileModal"
                data-bs-keyboard="false"
                tabIndex="-1"
                aria-labelledby="staticBackdropLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div
                        className={`modal-content ${mobileScreen ? "px-0 " : "px-3"} mx-2 `}
                    >
                        <div className="modal-header border-bottom-0 ">
                            <h1 className="modal-title fs-5 mt-2" id="staticBackdropLabel">
                                Applicant full profile
                            </h1>
                            <button
                                id="closeViewProfileButton"
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body border-bottom-0 ">
                            <div className="container px-0">
                                {professionalId !== null ? (
                                    <CandidateProfile
                                        professionalId={professionalId}
                                        mobileScreen={mobileScreen}
                                    />
                                ) : null}
                            </div>
                        </div>
                        <div className="modal-footer border-top-0">
                            <div className="container">
                                <div className="row float-end">
                                    <div className="col-lg-12 ">
                                        <button
                                            type="button"
                                            className="btn btn-outline-secondary"
                                            data-bs-dismiss="modal"
                                        >
                                            <span>Cancel</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BestFitCandidates